var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("拓撲階層")]), _vm._v(" —— 定義案場內各節點（電錶、INV、串列）與上下游的連接關係，並校正電錶名稱。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_vm._v("最上游節點的「上游節點編號」請留空；其餘節點須指向本案場已建立的節點。")]), _c('li', [_vm._v(" 串列的陣列位置"), _c('strong', [_vm._v("不可由節點編號推算")]), _vm._v("：若 INV 有未接線的輸入端，位置會跳號， 請以「MPPT串列對應」為準。 ")]), _c('li', [_vm._v(" 串列節點編號格式為 "), _c('code', [_vm._v("INV序號-MPPT編號-MPPT內序號")]), _vm._v("（例 "), _c('code', [_vm._v("INV1-3-1")]), _vm._v("）， 與「MPPT串列對應」共用同一組編號。 建議"), _c('strong', [_vm._v("先完成「MPPT串列對應」，再按「由遙測產生」")]), _vm._v("，否則串列編號需事後重編。 ")]), _c('li', [_vm._v("同一陣列位置只能對應一個節點，重複建立時系統會拒絕儲存。")])])]), _c('MasterDataTable', _vm._g({
    attrs: {
      "table": "inverter_topology_nodes",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };